import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _typeof from "@babel/runtime/helpers/esm/typeof";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { useCntfContent } from './useCntfContent';
export var PageTypes = /*#__PURE__*/function (PageTypes) {
  PageTypes["page"] = "page";
  return PageTypes;
}({});
export function useCntfPaginatableContent(id, itemsPerPage) {
  var pageParamName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : PageTypes.page;
  var _useCntfContent = useCntfContent(id),
    content = _useCntfContent.content,
    error = _useCntfContent.error,
    _pagination = _useCntfContent.pagination,
    _search = _useCntfContent.search,
    loading = _useCntfContent.loading;
  var route = useRoute();
  var page = computed(function () {
    var _route$query;
    return Math.max(Number((_route$query = route.query) === null || _route$query === void 0 ? void 0 : _route$query[pageParamName]) - 1 || 0, 0);
  });
  var search = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(query) {
      var result;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!(_typeof(query) === 'object' && Object.keys(query).length > 0)) {
              _context.next = 5;
              break;
            }
            _context.next = 3;
            return _search(_objectSpread({
              skip: page.value * itemsPerPage.value
            }, query));
          case 3:
            result = _context.sent;
            return _context.abrupt("return", result);
          case 5:
            return _context.abrupt("return", {});
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function search(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  var pagination = computed(function () {
    return {
      totalItems: _pagination.value.total,
      total: Math.ceil(_pagination.value.total / _pagination.value.limit) || 0
    };
  });
  return {
    content: content,
    error: error,
    pagination: pagination,
    search: search,
    loading: loading
  };
}